module.exports = __webpack_public_path__ + "static/media/footer-icons.68d025b4.svg";